import { render, staticRenderFns } from "./TestVideo.vue?vue&type=template&id=45f54d88&"
import script from "./TestVideo.vue?vue&type=script&lang=js&"
export * from "./TestVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports